<div id="aboutDiv" class="aboutDiv">
    <div align="center" class="aboutTitle">
      <br>
      <div class="form-group">
        <img class="logo" src="assets/images/MatrixCare_Logo.svg" alt="MatrixCare Logo" />
      </div>
      <br>
      <div class="aboutTitle">About MatrixCare</div>
      <hr>
    </div>
    <br>
    <div class="aboutText form-group">
      MatrixCare solutions have powered the long-term care continuum for more than 30 years. MatrixCare is the largest LTPAC technology provider in the United States and the first to offer a true, full-spectrum solution for facility-based care settings and home care and home health agencies. MatrixCare's solutions help matrixcare 360 and senior living providers, life plan communities (CCRCs), and home health organizations to prosper in a fee-for-value healthcare environment. Through its CareCommunity care coordination and population management platform, built on Microsoft Azure, MatrixCare offers the industry's first solution for helping the emerging set of conveners and diversified LTPAC operators deliver superior care and better outcomes across the full spectrum of care.
    </div>
    <br>
    <div class="aboutText">
      <a class="btn btn-primary btn-sm" [routerLink]="['/acknowledgements']">Acknowledgements</a>
    </div>
</div>
